import "./ProgressIndicator.less";
import {ProgressSection} from "./ProgressSection";

type ProgressIndicatorProps = {
    itemsToDiplay: [number, number, string][];
};

export const ProgressIndicator = ({itemsToDiplay}: ProgressIndicatorProps) => (
    <svg
        className="progress-indicator"
        width="596"
        height="38"
        viewBox="0 0 596 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            className="progress-indicator__background"
            x="2"
            y="2"
            width="592"
            height="34"
            rx="17"
            style={{
                fill: "#C4C4C4",
                stroke: "white",
                strokeWidth: "4px"
            }}
        />
        <mask id="mask0" mask-type="alpha" width="592" height="34">
            <rect width="588" x="4" y="4" height="30" rx="13" fill="#000" />
        </mask>
        <g mask="url(#mask0)">
            {itemsToDiplay.map(([x, area, fill]) => (
                <ProgressSection
                    className="progress-indicator__section"
                    x={x}
                    progress={area!}
                    fill={fill}
                />
            ))}
        </g>
    </svg>
);
